import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SocialLinks } from '../../shared/social-links/social-links';
import { ScrollToSectionDirective } from '../../shared/scroll-to-section.directive';
import { Toast } from '../../shared/toast/toast';

@Component({
  selector: 'app-header',
  imports: [RouterLink, SocialLinks, ScrollToSectionDirective],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  protected readonly toast = inject(Toast);
}
